import { render, staticRenderFns } from "./ReportPaidPromotion.vue?vue&type=template&id=37b9724b"
import script from "./ReportPaidPromotion.vue?vue&type=script&lang=js"
export * from "./ReportPaidPromotion.vue?vue&type=script&lang=js"
import style0 from "./ReportPaidPromotion.vue?vue&type=style&index=0&id=37b9724b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports